module.exports = __webpack_public_path__ + "static/img/invite11.47b4da0.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/invite11.png
// module id = 914
// module chunks = 1